import { render, staticRenderFns } from "./MyEventsList.vue?vue&type=template&id=86aaf2c6&scoped=true"
import script from "./MyEventsList.vue?vue&type=script&lang=js"
export * from "./MyEventsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86aaf2c6",
  null
  
)

export default component.exports